import React from 'react'
import MovieCard from './components/MovieCard'

const App = () => {
  return (
    <div className="App">
      <MovieCard />
    </div>
  );
}

export default App
